import React, {Fragment, useEffect, useState} from 'react';
import {Col, Modal, ModalBody, ModalHeader, Row,} from "reactstrap";
import GaugeChart from 'react-gauge-chart'
import ImageModal from './image-Modal.js';
import { toPng } from 'html-to-image';
import GeneratePdf from '../PDF/generatePDF.js';
import {TOTAL} from '../../../common/constants.js';

const LenovoModel = ({rowData, leadData, openAuditModal, setOpenAuditModal}) => {

    const { score = [], questions = [] } = leadData || {};
    const totalScore = score?.find(item => item.score_type === TOTAL)?.value ?? [];
    const otherScores = score?.filter(item => item.score_type !== TOTAL) ?? [];

    const [openImageModal, setOpenImageModal] = useState(false);
    const [imageData, setImageData] = useState('');


    const getBgColor = (value) => {
        if (value < 80) return "#EA4228";
        if (value < 85) return "#F5CD19";
        return "#5BE12C";
    };


    return (
        <>
            <ImageModal open={openImageModal} setOpen={setOpenImageModal} imageData={imageData}/>
            <Modal
                // className="modal-fullscreen"
                id="exampleModalFullscreen"
                tabIndex="-1"
                isOpen={openAuditModal}
                toggle={() => {
                    setOpenAuditModal(false);
                }}
                centered={true}
                size={"xl"}
            >
                <div className="d-flex justify-content-end align-items-center">
                    <GeneratePdf
                        leadData={leadData}
                        rowData={rowData}
                    />
                    <ModalHeader
                        className="p-3"
                        toggle={() => {
                            setOpenAuditModal(false);
                        }}
                    >
                    </ModalHeader>
                </div>
                <ModalBody style={{overflowX: "scroll"}}>
                    <Row style={{background: "#d7f7fc"}}>
                        <Col>
                            <div className="py-4 px-5 mt-3" style={{background: "#fff"}}>
                                <h3 className="text-body mb-3">Audit Lead Details</h3>
                                <p>Lead ID: {rowData.lead_id}</p>
                                <p>Merchant Name: {rowData.merchant_name}</p>
                                <p>Merchant number: {rowData.merchant_number}</p>
                            </div>

                            <div className="py-4 px-5 mt-3" style={{background: "#fff"}}>
                                <h3 className="text-body text-center mb-4">Final Grade</h3>
                                <div id="pdf-gauge-chart" className="d-flex justify-content-around align-items-center">
                                    <GaugeChart id="gauge-chart6"
                                                nrOfLevels={3}
                                                percent={totalScore / 100}
                                                arcsLength={[0.8, 0.05, 0.15]}
                                                colors={['#EA4228', '#F5CD19', '#5BE12C']}
                                                arcPadding={0.01}
                                                needleColor="#345243"
                                                textColor="#ccc"
                                                style={{width: 600}}
                                    />
                                    <h2 className="m-0 p-3 px-4 rounded-pill"
                                        style={{
                                            color: '#fff',
                                            fontSize: '48px',
                                            backgroundColor: getBgColor(totalScore)
                                        }}>{totalScore}</h2>
                                </div>
                                <h2 className="text-body text-center mb-4">Chapters summary</h2>
                                <div className="mx-auto" style={{maxWidth: 800}}>

                                    {otherScores.map((item, index) => (
                                        <div className="border border-1 d-flex align-items-center"
                                             style={{
                                                 background: "#fff",
                                                 fontSize: "14px",
                                                 padding: "8px 24px 12px 32px",
                                                 width: "100%"
                                             }} key={index}>

                                                <p className="m-0 flex-grow-1">{item.score_type}</p>
                                                <div className="d-flex flex-column overflow-hidden align-items-center"
                                                     style={{width: 120}}>
                                                    <p className="m-0 p-2 px-3 rounded-pill"
                                                       style={{
                                                           color: '#fff',
                                                           backgroundColor: getBgColor(item.value)
                                                       }}>{item.value}
                                                    </p>
                                                    <p style={{
                                                        fontSize: '12px',
                                                        paddingTop: '8px',
                                                        margin: 0
                                                    }}>{item.score}</p>
                                                </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                            <div className="py-4 px-5">
                                {questions.map((item, index) => (
                                    <div style={{
                                        background: "#fff",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        padding: "4px 0"
                                    }} key={index}>
                                        <div style={{padding: "16px 100px 12px 24px"}}
                                             className="d-flex justify-content-between">
                                            <p className="m-0">{item.question}</p>
                                            <p className="m-0">{item.answer}</p>
                                        </div>
                                        <p className="mx-2 my-0"
                                           style={{background: "#f0f7eb", padding: "8px 24px"}}>{item.comment}</p>

                                        {item.image &&
                                            <div className="p-3 d-flex justify-content-center mt-2"
                                                 style={{background: "#d7f7fc"}}>
                                                <img
                                                    className="cursor-pointer"
                                                    style={{maxWidth: "240px", maxHeight: "240px"}}
                                                    src={item.image}
                                                    crossOrigin="anonymous"
                                                    alt={item.question}
                                                    onClick={() => {
                                                        setOpenImageModal(true);
                                                        setImageData(item.image);
                                                    }}
                                                />
                                            </div>
                                        }
                                    </div>
                                ))}
                            </div>
                        </Col>

                    </Row>
                </ModalBody>
            </Modal>
        </>
    );
};

export default React.memo(LenovoModel);